import gql from "graphql-tag"
import { useMutation } from "react-apollo"
import { CreateEmailListMutation, CreateEmailListMutationVariables } from "typings/types"

const CREATE_EMAIL_LIST = gql`
  mutation CreateEmailList($emailList: CreateEmailListParams!) {
    createEmailList(emailList: $emailList) {
      id
    }
  }
`

export const useCreateEmailList = () =>
  useMutation<CreateEmailListMutation, CreateEmailListMutationVariables>(CREATE_EMAIL_LIST)
